export const pkg = {
  name: 'isomorphic-git',
  version: '1.37.0',
  agent: 'git/isomorphic-git@1.37.0',
}
